import { APIFailureProvider } from "components/app/APIFailureContext";
import { HandleApiFailure } from "components/common/HandleApiFailure";
import RouteChangeTracker from "components/features/AboveProperty/RouteChangeTracker/RouteChangeTracker";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./components/app/App";
import "./index.scss";
import { persistor, store } from "./redux/store";
import "./styles/fonts.scss";

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <RouteChangeTracker />
      <APIFailureProvider>
        <HandleApiFailure />
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </APIFailureProvider>
    </BrowserRouter>
  </Provider>
);
